import { databases } from "@/lib/appwrite";
import { userCacheManager } from "@/lib/manager realtime/userCache";
import { sendLeaveStatusToN8n } from "@/requests/leaves/webhook/sendLeaveStatusToN8n";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const LEAVES_COLLECTION_ID = import.meta.env.VITE_LEAVES_REQUESTS_COLLECTION_ID;

interface UpdateLeaveRequestParams {
    requestId: string;
    action: 'approve' | 'reject';
    rrhhUserId: string;
    rejectionReason?: string;
    leaveUserId: string;
    leaveTitle: string;
    // Nuevos campos para el webhook
    startDate: string;
    endDate: string;
    allDay: boolean;
    totalDuration: number;
}

export async function updateLeaveRequestByRRHH({
    requestId,
    action,
    rrhhUserId,
    rejectionReason,
    leaveUserId,
    leaveTitle,
    startDate,
    endDate,
    allDay,
    totalDuration,
}: UpdateLeaveRequestParams) {
    try {
        const isApprove = action === 'approve';

        const data = isApprove
            ? {
                statusByRrhh: 'approved',
                status: 'approved',
                approvedById: rrhhUserId,
                idRejectedByRrhh: null,
            }
            : {
                statusByRrhh: 'rejected',
                status: 'rejected',
                idRejectedByRrhh: rrhhUserId,
                approvedById: null,
                rejectionReasonByRrhh: rejectionReason,
            };

        await databases.updateDocument(
            DATABASE_ID,
            LEAVES_COLLECTION_ID,
            requestId,
            data
        );

        // Enviar webhook a n8n
        try {
            const usersMap = userCacheManager.getUsersMap();
            const leaveUser = usersMap.get(leaveUserId);
            const approverUser = usersMap.get(rrhhUserId);

            await sendLeaveStatusToN8n(
                isApprove ? 'approved' : 'rejected',
                requestId,
                leaveTitle,
                leaveUser?.name ?? "",
                leaveUser?.email ?? "",
                startDate,
                endDate,
                allDay,
                totalDuration,
                rejectionReason,
                approverUser?.email ?? ""
            );
        } catch (webhookError) {
            console.warn("Error enviando webhook (registro actualizado):", webhookError);
        }

        return {
            success: true,
            message: isApprove ? 'Solicitud aprobada correctamente' : 'Solicitud rechazada correctamente',
        };
    } catch (error) {
        console.error("Error updating leave request:", error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido',
        };
    }
}